const actions = {
  SCREENING_SEND_IDV_INVITATION_TO_VERIFY: 'SCREENING_SEND_IDV_INVITATION_TO_VERIFY',
  SCREENING_SEND_IDV_INVITATION_TO_VERIFY_SUCCESS:
    'SCREENING_SEND_IDV_INVITATION_TO_VERIFY_SUCCESS',
  SCREENING_SEND_IDV_INVITATION_TO_VERIFY_FAILURE:
    'SCREENING_SEND_IDV_INVITATION_TO_VERIFY_FAILURE',

  SCREENING_GET_USER_INFROMATION: 'SCREENING_GET_USER_INFROMATION',
  SCREENING_GET_USER_INFROMATION_SUCCESS: 'SCREENING_GET_USER_INFROMATION_SUCCESS',
  SCREENING_GET_USER_INFROMATION_FAILURE: 'SCREENING_GET_USER_INFROMATION_FAILURE',

  SCREENING_UPDATE_USER_GENERAL_INFORMATION: 'SCREENING_UPDATE_USER_GENERAL_INFORMATION',

  SCREENING_UPDATE_FRONT_PAGE_DOCUMENT: 'SCREENING_UPDATE_FRONT_PAGE_DOCUMENT',
  SCREENING_UPDATE_FRONT_BACK_DOCUMENT: 'SCREENING_UPDATE_BACK_PAGE_DOCUMENT',

  SCREENING_UPDATE_SELFIE: 'SCREENING_UPDATE_SELFIE',

  SCREENING_UPDATE_SELECTED_DOCUMENT_TYPE: 'SCREENING_UPDATE_SELECTED_DOCUMENT_TYPE',

  SCREENING_UPDATE_USER_INFROMATION: 'SCREENING_UPDATE_USER_INFROMATION',
  SCREENING_UPDATE_USER_INFROMATION_SUCCESS: 'SCREENING_UPDATE_USER_INFROMATION_SUCCESS',
  SCREENING_UPDATE_USER_INFROMATION_FAILURE: 'SCREENING_UPDATE_USER_INFROMATION_FAILURE',
}

export default actions
